import React, { useContext, useEffect, useRef, useState } from "react";
import Animation from "../../../../../components/Components/lotties/waitingSignature.json";
import Lottie from "lottie-react";
import FadeIn from "react-fade-in";
import secure from "./../../../../../assets/img/secure.svg";
import "./../css/waitingSignature.scss";
import StarIcon from "@material-ui/icons/Star";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import { I18nContext } from "../../../../../context/i18n.context";
import { ButtonDS } from "get-life-storybook-ts";
import { useQuery } from "../../../../../context/GetLifeContext.context";
import HttpLeadRepository from "../../../../../api/request/Lead/Lead.service";
import NativeRenewalConfirmation from "./NativeRenewalConfirmation";

/**
 * Confirmación de renovación desde el aviso. Con el enlace native (`t`, token
 * firmado por ms-agl; F3.4 P4, D20) la confirma el gateway; con el enlace de
 * siempre (`leadId`, `token`, `year`) el monolito. En los dos casos solo se
 * felicita al cliente si la confirmación ha entrado (antes salía siempre).
 */
export default function RenewalConfirmation() {
  let query = useQuery();
  const nativeToken = query.get("t");
  if (nativeToken) {
    return <NativeRenewalConfirmation token={nativeToken} />;
  }
  return <LegacyRenewalConfirmation query={query} />;
}

// translate() devuelve la clave si falta la traducción: fallback IT.
const withFallback = (translate) => (key, fallback) => {
  const value = translate(key);
  return value === key ? fallback : value;
};

// Rechazos del monolito con su propio texto (29-oct-2026: antes eran un 500 y el
// cliente veía el error genérico): 409 = plazo de confirmación vencido
// (RENEWAL_WINDOW_CLOSED), 422 = el código del enlace no es el suyo
// (RENEWAL_CODE_NOT_VALID). Se distinguen por el estado HTTP: el cuerpo trae
// además un `message` que el core pone delante del código.
const legacyRejection = (error) => {
  if (409 === error?.status) {
    return "expired";
  }
  if (422 === error?.status) {
    return "invalid";
  }
  return "error";
};

const SUPPORT_EMAIL = "supporto@life5.it";
const SUPPORT_PHONE = "02 8294 21 28";

function LegacyRenewalConfirmation({ query }) {
  const leadId = query.get("leadId");
  const token = query.get("token");
  const year = query.get("year");

  const rateUs = () => {
    window.open(translate("trustpilot.link"), "_blank");
  };

  const {
    state: { translate },
  } = useContext(I18nContext);
  const t = withFallback(translate);

  const [result, setResult] = useState(leadId && token && year ? "pending" : "error");
  const sent = useRef(false);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    if (sent.current || !(leadId && token && year)) {
      return;
    }
    sent.current = true;
    new HttpLeadRepository()
      .postConfirmRenewalAgl(leadId, parseInt(token), parseInt(year))
      .then(() => setResult("ok"))
      .catch((error) => setResult(legacyRejection(error)));
  }, []);

  if ("ok" !== result) {
    return (
      <div className={"waitingSignature-outerContainer"}>
        <div className={"waitingSignature-container"}>
          <section className="waitingSignature-topContainer">
            <div className="waitingSignature-topContent" data-testid="legacy-renewal" data-state={result}>
              {"pending" === result ? (
                <p className="waitingSignature-p">
                  {t("renewalConfirmation.native.pending", "Stiamo confermando il rinnovo…")}
                </p>
              ) : (
                <>
                  <p className="waitingSignature-congratsBold">
                    {"expired" === result
                      ? t("renewalConfirmation.legacy.expiredTitle", "Il termine per confermare il rinnovo è scaduto")
                      : "invalid" === result
                        ? t("renewalConfirmation.legacy.invalidTitle", "Il link di conferma non è valido")
                        : t("renewalConfirmation.native.errorTitle", "Non siamo riusciti a confermare il rinnovo")}
                  </p>
                  <p style={{ paddingTop: "29px" }} className="waitingSignature-p">
                    {"expired" === result
                      ? t(
                          "renewalConfirmation.legacy.expiredText",
                          "Non è più possibile confermare il rinnovo online. Contattaci e ti aiutiamo noi."
                        )
                      : "invalid" === result
                        ? t(
                            "renewalConfirmation.legacy.invalidText",
                            "Controlla di aver aperto il link dell'ultima email che ti abbiamo inviato, oppure contattaci."
                          )
                        : t("renewalConfirmation.legacy.errorText", "Il link non è valido o è scaduto.")}
                  </p>
                  <p className="waitingSignature-p" data-testid="legacy-renewal-contact">
                    {t("renewalConfirmation.native.contact", "Scrivici a")}{" "}
                    <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>{" "}
                    {t("renewalConfirmation.native.orCall", "o chiamaci allo")}{" "}
                    <a href={`tel:${SUPPORT_PHONE.replace(/\s/g, "")}`}>{SUPPORT_PHONE}</a>.
                  </p>
                </>
              )}
            </div>
          </section>
        </div>
      </div>
    );
  }

  return (

    <div className={"waitingSignature-outerContainer"}>
      <FadeIn>
        <div className={"waitingSignature-container"}>
          <section className="waitingSignature-topContainer">
            <div className="waitingSignature-topContent">
              <Lottie
                className="waitingSignature-animation"
                animationData={Animation}
                loop={false}
              />
              <p className="waitingSignature-congrats">
                {translate("renewalConfirmation.congratulations")}
              </p>
              <p className="waitingSignature-congratsBold">{translate("renewalConfirmation.superTitle1")}</p>
              <p style={{ paddingTop: "29px" }} className="waitingSignature-p">
                {translate("renewalConfirmation.titleText1")}
              </p>
              <p className="waitingSignature-p">{translate("renewalConfirmation.subtitleText1")}</p>

            </div>
          </section>

          <section className="waitingSignature-botomContainer">
            <article className="waitingSignature-boxContainer">
              <div className="waitingSignature-boxContent">
               
                  <>
                    <p className="waitingSignature-box-title">
                      <p>{translate("renewalConfirmation.experience")} </p>
                      <div className="waitingSignature-starsContent">
                        <StarIcon
                          fontSize={"small"}
                          className={"waitingSignature_stars_icon_active"}
                        />
                        <StarIcon
                          fontSize={"small"}
                          className={"waitingSignature_stars_icon_active"}
                        />
                        <StarIcon
                          fontSize={"small"}
                          className={"waitingSignature_stars_icon_active"}
                        />
                        <StarIcon
                          fontSize={"small"}
                          className={"waitingSignature_stars_icon_active"}
                        />
                        <StarHalfIcon
                          fontSize={"small"}
                          className={"waitingSignature_stars_icon_active"}
                        />
                        ?
                      </div>
                    </p>
                    <p className="waitingSignature-box-title">
                      {translate("renewalConfirmation.comment")}
                    </p>
                    <p className="waitingSignature-trusPilotLabel">
                      {translate("renewalConfirmation.trustpilot")}
                    </p>
                    <div className="waitingSignature-starBox">
                      <div className="waitingSignature-TruststarContainer">
                        <p className="waitingSignature-points">4.6</p>
                        <div className="waitingSignature-starsContent">
                          <StarIcon
                            fontSize={"small"}
                            className={"waitingSignature_stars_icon_active"}
                          />
                          <StarIcon
                            fontSize={"small"}
                            className={"waitingSignature_stars_icon_active"}
                          />
                          <StarIcon
                            fontSize={"small"}
                            className={"waitingSignature_stars_icon_active"}
                          />
                          <StarIcon
                            fontSize={"small"}
                            className={"waitingSignature_stars_icon_active"}
                          />
                          <StarHalfIcon
                            fontSize={"small"}
                            className={"waitingSignature_stars_icon_active"}
                          />
                        </div>
                      </div>
                      <div className="waitingSignature-starButtonContainer">
                        <ButtonDS
                          onClick={rateUs}
                          label={translate("renewalConfirmation.btnComment")}
                        />
                      </div>
                    </div>
                  </>
              </div>
            </article>
          </section>
          <div className="waitingSignature-footerContainer">
            <img src={secure} alt="aplicación segura" />
            <p className="waitingSignature-footer">
              {translate("paymentFooter.text")}
            </p>
          </div>
        </div>
      </FadeIn>
    </div>
  );
}
